import React, { useContext} from 'react';
import { Container, Tooltip, OverlayTrigger, Col } from 'react-bootstrap';
import PortfolioContext from '../../context/context';
import Title from '../Title/Title';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { Fade } from "react-awesome-reveal";

library.add(fab);
library.add(fas);


const Skills = () => {
    const { skills, experiences } = useContext(PortfolioContext);
    const { skillsIcons } = skills;
    const { experience } = experiences;
  
    return (
      <>
       <Title title="Skills & Experiences"/>
       <Container className="app__skills-container" fluid>
       <Fade triggerOnce direction='down' duration={1000} delay={1200}>
       <div className="app__skills-list">
          {skillsIcons &&
            skillsIcons.map(skill => {
              const { id, icon, name, color } = skill;
              const iconType = icon === 'database' ? 'fas' : 'fab'
              return (
                <Col key={id} className='app__skills-item' md='2'>
                  <FontAwesomeIcon color={`${color}`} className='icon' icon={[`${iconType}`, `${icon}`]} size='6x' fixedWidth  />
                  <p className="p-text">{name}</p>
                </Col>
                );
            })}
        </div>
        </Fade>
        <Fade triggerOnce direction='right' duration={1000} delay={1400}>
        <div className="app__skills-exp">
          {experience &&
            experience.map((experience) => (
            <div
              className="app__skills-exp-item"
              key={experience.id}
            >
              <div className="app__skills-exp-year">
                <p className="bold-text">{experience.year}</p>
              </div>
              <div className="app__skills-exp-works">
              {experience.jobs.map((job) => (
                      job.desc ? (
                        <OverlayTrigger
                          key={job.name}
                          placement='top'
                          overlay={
                            <Tooltip id={`tooltip-${job.name}`} className="skills-tooltip">
                              {job.desc}
                            </Tooltip>
                          }
                        >
                          <div className="app__skills-exp-work" data-for={job.name} key={job.name}>
                            <h4 className="bold-text">{job.name}</h4>
                            <p className="p-text">{job.company}</p>
                          </div>
                        </OverlayTrigger>
                      ) : (
                        <div className="app__skills-exp-work" key={job.name}>
                          <h4 className="bold-text">{job.name}</h4>
                          <p className="p-text">{job.company}</p>
                        </div>
                      )
                    ))}
              </div>
            </div>
            ))}
        </div>
        </Fade>
       </Container>
      </>
    );
  };

export default Skills;